// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container-footer-observation-entry\n{\n    width: -webkit-fill-available !important;\n}", "",{"version":3,"sources":["webpack://./src/components/app/panelDocument.css"],"names":[],"mappings":"AAAA;;IAEI,wCAAwC;AAC5C","sourcesContent":[".container-footer-observation-entry\n{\n    width: -webkit-fill-available !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
